import AlertBannertImg from 'assets/images/alert-banner.png';
import { useAppSelector } from 'hooks/useAppSelector';
import { useNavigate } from 'react-router-dom';
import { getHasPrimaryCity } from 'reduxStore/reducers/ProfileSlice/selectors/getHasPrimaryCity';
import { AlertBannerBlock } from '../AlertBannerBlock';

export const PrimaryCityBanner = () => {
  const navigate = useNavigate();
  const hasPrimaryCity = useAppSelector(getHasPrimaryCity);
  const defaultImg = <img src={AlertBannertImg} alt="" className="h-20 w-20" />;

  const clickHandler = () => {
    navigate('/profile/private');
  };

  return (
    <div className="mb-6">
      {hasPrimaryCity === true && (
        <AlertBannerBlock
          title={<p>Проверьте свои города обслуживания</p>}
          description={
            <p>
              Уважаемый пользователь, у вас не указан основной город обслуживания. Пожалуйста,
              актуализируйте информацию в Профиле.
            </p>
          }
          buttonName="Перейти в профиль"
          onClick={clickHandler}
          icon={defaultImg}
        />
      )}
    </div>
  );
};
